export class DateConstants {
    public static readonly AM = 'a.m.';
    public static readonly MiddayHour = 12;
    public static readonly Locale = 'en-US';
    public static readonly PM = 'p.m.';
    public static readonly BeginningOfTime = new Date(1970, 0, 1);
}
